import { render, staticRenderFns } from "./MovementOrderItemDetail.vue?vue&type=template&id=21a6ae90&scoped=true&"
import script from "./MovementOrderItemDetail.vue?vue&type=script&lang=js&"
export * from "./MovementOrderItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./MovementOrderItemDetail.vue?vue&type=style&index=0&id=21a6ae90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6ae90",
  null
  
)

export default component.exports